module.exports = __webpack_public_path__ + "static/media/stantionSMall.ac9e9684.png";